@if (value() && value().length > 0) {
    <div
        #triggerOverlay="cdkOverlayOrigin"
        class="st-story-icon-list__value"
        cdkOverlayOrigin
        (mouseleave)="onMouseOut($event)"
        (mouseenter)="openOverlay()">
        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="triggerOverlay"
            [cdkConnectedOverlayOpen]="isPanelOpen()"
            (attach)="panelAttached()">
            <mat-selection-list
                matSelectionList
                hideSingleSelectionIndicator
                class="st-story-icon-list__overlay"
                [multiple]="false">
                @for (story of value(); track story) {
                    <mat-list-option
                        [value]="story"
                        (click)="onItemClicked(story)">
                        <div class="st-story-icon-list__overlay__grid">
                            <div class="st-story-icon-list__overlay__grid__icon">
                                <st-story-icon
                                    hasBorder
                                    [attr.disabled]="cardDisabled()"
                                    [type]="story?.PSTStoryOutputType"
                                    [data]="story"
                                    (click)="onItemClicked(story)" />
                            </div>
                            <div class="st-story-icon-list__overlay__grid__details">
                                <div class="st-story-icon-list__overlay__item-text">{{ story?.Title }}</div>
                                <div class="st-story-icon-list__overlay__item-owner">
                                    {{ globalTablesService.Staff?.[story?.PSTStoryOwner?.[0]]?.DisplayName || '' }}
                                </div>
                            </div>
                        </div>
                    </mat-list-option>
                }
            </mat-selection-list>
        </ng-template>
        <div class="st-story-icon-list__icons">
            @for (item of itemsToShow(); track item; let first = $first) {
                <st-story-icon
                    hasBorder
                    [attr.disabled]="cardDisabled()"
                    [type]="item?.PSTStoryOutputType"
                    [data]="item"
                    (click)="onItemClicked(item)" />
            }
        </div>
    </div>
    @if (shouldShowExtraItems()) {
        <div
            #triggerOverlay="cdkOverlayOrigin"
            class="st-story-icon-list__value__extra-items"
            cdkOverlayOrigin
            (mouseenter)="openOverlay()"
            (mouseleave)="onMouseOut($event)">
            +{{ extraItemsCount() }}
        </div>
    }
}

@if (showAddButton()) {
    @if (hasButtonLabel()) {
        <button
            mat-button
            class="st-story-icon-list__add-story-button"
            [disabled]="cardDisabled()"
            [matMenuTriggerFor]="templatesMenu"
            (menuClosed)="createStories(storyTemplateList)">
            <mat-icon> edit_note </mat-icon>
            {{ addStoryLabel() }}
        </button>
    } @else {
        <button
            mat-icon-button
            class="st-story-icon-list__add-story-button"
            [disabled]="cardDisabled()"
            [matMenuTriggerFor]="templatesMenu"
            (menuClosed)="createStories(storyTemplateList)">
            <mat-icon> edit_note </mat-icon>
        </button>
    }
}

<mat-menu
    #templatesMenu="matMenu"
    st-click-stop-propagation>
    <mat-selection-list
        #storyTemplateList
        class="st-story-icon-list__menu"
        st-click-stop-propagation>
        @for (item of templates(); track item) {
            <mat-list-option
                st-click-stop-propagation
                [dir]="isRTL()"
                [value]="item">
                <st-story-icon
                    hasBorder
                    [attr.disabled]="cardDisabled()"
                    [type]="item?.PSTStoryOutputType"
                    [data]="item" />
                <div class="st-story-icon-list__menu__item-text">
                    {{ item?.Title }}
                </div>
            </mat-list-option>
        }
    </mat-selection-list>
</mat-menu>
